import { ICandidate } from '@/shared/api-client/models/candidate';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class CandidateProfilePictureComponent extends Vue {
    @Prop({default: null}) public candidate!: ICandidate | null;
    @Prop({default: null}) public fileName!: string | null;

    @Prop({default: 80}) public width!: number;
    @Prop({default: 100}) public height!: number;
    @Prop({default: true}) public crop!: number;

    public get hasPicture(): boolean {

        if (this.fileName && this.fileName.length > 0) {
            return true;
        }

        if (this.candidate &&
            this.candidate.userData &&
            this.candidate.userData.pictureFileName &&
            this.candidate.userData.pictureFileName !== '') {

            return true;
        }

        return false;
    }

    public get getUrl(): string | null {

        let src: string = '';

        if (this.fileName && this.fileName.length > 0) {
            src = this.fileName;
        }

        if (this.candidate &&
            this.candidate.userData &&
            this.candidate.userData.pictureFileName &&
            this.candidate.userData.pictureFileName !== '') {

            src = this.candidate.userData.pictureFileName;
        }

        if (src === undefined || src === '') {
            return null;
        }

        return `url(/file/image/${src}?width=${this.width}&height=${this.height}${(this.crop ? '&mode=crop' : '')})`;
    }
}
